import { constants } from "utils";

// Which create controls the Create Groups row shows for the warm_up_challenges
// flag status ({ enabled, isLoading } from useFeatureFlagStatus): none until
// the answer arrives, the single menu when on, today's buttons when off.
export const createControlsFor = ({ enabled, isLoading }) => {
  if (isLoading) return "none";
  return enabled ? "menu" : "buttons";
};

// The warm-up set picker, opened for one class.
export const warmUpPickerUrl = (classroomId) =>
  `${constants.WARM_UP_PICKER_PATH}?${new URLSearchParams({ classroomId: classroomId || "" })}`;
